// src/components/Tooltip.jsx
import React, { useState } from 'react';
import ReactDOM from 'react-dom';

export default function Tooltip({ children, content }) {
  const [visible, setVisible] = useState(false);
  return (
    <span
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      className="relative inline-block"
    >
      {children}
      {visible && ReactDOM.createPortal(
        <div className="absolute z-50 bg-[#1e293b] text-white p-3 rounded shadow-lg whitespace-nowrap" style={{ transform: 'translate(-50%, -100%)', left: '50%' }}>
          {content}
        </div>,
        document.body
      )}
    </span>
  );
}
